import React from 'react';

import { Flex, Text } from '@vimeo/bokeh';

import { ErrorType, ErrorTypes, SHOWCASE_ERROR_MESSAGE } from './constants';

interface ShowcaseErrorScreenProps {
  errorType?: ErrorType;
}
const ShowcaseErrorScreen = ({
  errorType = ErrorTypes.PRIVACY_ERROR,
}: ShowcaseErrorScreenProps) => (
  <Flex
    alignContent="center"
    background="linear-gradient(180deg, rgba(20, 21, 22, 0) 0%, #141516 100%)"
    display="flex"
    flexDirection="column"
    height="100vh"
    justifyContent="center"
    textAlign="center"
    width="100vw"
  >
    <Text variant="heading" color="white" display="block" fontWeight="700">
      {SHOWCASE_ERROR_MESSAGE[errorType]?.heading}
    </Text>
    <Text variant="heading" color="white">
      {SHOWCASE_ERROR_MESSAGE[errorType]?.body}
    </Text>
  </Flex>
);

export default ShowcaseErrorScreen;
